<template>
    <div id="artists" v-if="data" class="fade">
        <div class="row" style="">
            <div class="col-sm-12 big-title">
                <p class="h1 artwork-title text-center">ARTISTS</p>
            </div>
        </div>
        <div v-for="(item, key) in data" :id="item.ID" :key="item.ID" class="edition-wrap" :style="'color:'+ item.acf.color">
            <div v-if="key == 0" class="h22 border-bottom">{{ item.post_title.charAt(0) }}</div>
            <div v-else-if="key > 0 && item.post_title.charAt(0) != data[key-1].post_title.charAt(0)" class="h22 artist-letter border-bottom">{{ item.post_title.charAt(0) }}</div>
            <Artist :item="item" :status="false"></Artist>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import Artist from './Artist'

export default {
    name: 'Artists',
    data() {
        return {
            data: null,
            pending: true,
            error: null,

        }
    },
    components: {
        Artist
    },
    computed: {
        page() {
            return this.$store.state.isPage;
        },
        query() {
            return this.$route.query.id
        }
    },
    mounted() {
        this.requestData()
        let self = this;

        setTimeout(function() {
            if (self.query && self.query != "") {
                let myElement, target;
                myElement = document.getElementById('page');
                target = document.getElementById(self.query.toString());
                self.animate(myElement, "scrollTop", "", 100, target.offsetTop - 65, 0, true);
            }
        }, 1000)

        this.$store.dispatch('getEchoesContributions');
    },
    methods: {
        async requestData() {
            this.pending = true
            try {
                const { data } = await axios.get(`${this.$store.state.api}/get_artists`, { params: { id: 'home' } })
                this.data = data;
                this.error = false;
                this.$store.commit('setPage', '/artists')
                this.$store.commit('setIsPage', true)
            } catch (e) {
                this.data = null;
                this.error = e;
            }
            this.pending = false;
        },
        animate: function(elem, style, unit, from, to, time, prop) {

            if (!elem) {
                return;
            }
            var start = new Date().getTime(),
                timer = setInterval(function() {
                    var step = Math.min(1, (new Date().getTime() - start) / time);
                    if (prop) {
                        elem[style] = (from + step * (to - from)) + unit;
                    } else {
                        elem.style[style] = (from + step * (to - from)) + unit;
                    }
                    if (step === 1) {
                        clearInterval(timer);
                    }
                }, 25);
            if (prop) {
                elem[style] = from + unit;
            } else {
                elem.style[style] = from + unit;
            }
        }

    },
    watch: {
        query(n, o) {
            let myElement, target;
            if (n && n != o) {
                console.log(n.toString());
                myElement = document.getElementById('page');
                target = document.getElementById(n.toString());
                this.animate(myElement, "scrollTop", "", 100, target.offsetTop - 65, 0, true);
            }
        }
    }
}
</script>